module.exports = __webpack_public_path__ + "media/images/first-registration-background-0b5694532d61763dd887a19448ba2dc0.png";